<template>
  <div class="article-notification">
    <v-alert
      v-if="isRetracted"
      class="elevation-0 article-notification__container--warning mt-3"
    >
      <div class="d-flex">
        <v-icon
          class="article-notification__icon--warning mr-3 d-flex align-baseline"
        >
          {{ mdiAlertOutline }}
        </v-icon>
        <div>
          <h2 class="article-notification__title mb-2">Retraction notice</h2>
          <ToggleMoreSection
            button-classes="mt-2"
            @toggle="toggleShowRetractionSection"
          >
            <div class="article-notification__message">
              {{ article.retraction.response.message }}
            </div>
            <template #toggleButtonText>
              <div class="toggle-more">
                <span class="toggle-more__text toggle-more__text--warning">
                  {{ showRetractionSection ? `Show less` : `Show more` }}
                  <span class="d-sr-only">retraction notice</span>
                </span>
                <v-icon
                  small
                  class="toggle-more__text toggle-more__text--warning"
                >
                  {{ showRetractionSection ? mdiChevronUp : mdiChevronDown }}
                </v-icon>
              </div>
            </template>
          </ToggleMoreSection>
        </div>
      </div>
    </v-alert>
  </div>
</template>

<script>
import { mdiAlertOutline, mdiChevronUp, mdiChevronDown } from "@mdi/js";
import ToggleMoreSection from "~/components/page/components/buttons/ToggleMoreSection.vue";

export default {
  name: "ArticleNotification",
  components: {
    ToggleMoreSection,
  },
  props: {
    article: { type: Object, required: true },
  },
  data() {
    return {
      showRetractionSection: false,
      mdiAlertOutline,
      mdiChevronUp,
      mdiChevronDown,
    };
  },
  computed: {
    isRetracted() {
      const { retraction } = this.article;

      return retraction?.response?.retractionStatus === "ACCEPTED";
    },
  },
  methods: {
    toggleShowRetractionSection(value) {
      this.showRetractionSection = value;
    },
  },
};
</script>

<style lang="scss" scoped>
.article-notification {
  &__container {
    &--warning {
      color: #804400;
      background-color: #fff7e9;
      border: 1px solid #804400;
    }
  }

  &__title {
    font-size: 16px;
    font-weight: 700;
  }
  &__icon {
    &--warning {
      color: #804400;
      margin-top: -4px;
    }
  }
  &__message {
    font-size: 16px;
    font-weight: 400;
    line-height: 24px;
  }
}
.toggle-more {
  &__text {
    font-size: 16px;
    font-weight: 600;

    &--warning {
      color: #804400 !important;
    }
  }
}
</style>
